import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '../api';
import { authReducer } from './auth-slice';
import { adminAuthReducer } from './admin-auth-slice';
import { carrinhoReducer } from './carrinho-slice';
import { temaReducer } from './tema-slice';
import { selfServiceKioskReducer } from './self-service-kiosk-slice';
import totemPedidosReducer from './totem-pedidos-slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    adminAuth: adminAuthReducer,
    carrinho: carrinhoReducer,
    tema: temaReducer,
    selfServiceKiosk: selfServiceKioskReducer,
    totemPedidos: totemPedidosReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
